var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React, { useState } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { Collapse, Button } from 'reactstrap';
import { FiChevronRight } from 'react-icons/fi';
import LayersInput from './LayersInput';
import styled from 'styled-components';
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var CategoryButton = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: calc(100% + 4rem);\n  align-items: center;\n  padding: 1.5rem 2rem;\n  margin-left: -2rem;\n  margin-right: -2rem;\n  border-radius: 0;\n  &.btn.btn--depth0 {\n    box-shadow: inset 0 -1px 0 #e0e2e5;\n    &:not(:disabled):not(.disabled):hover,\n    &:not(:disabled):not(.disabled):focus {\n      box-shadow: inset 0 -1px 0 #e0e2e5;\n    }\n  }\n  &.btn.btn--depth1 {\n    box-shadow: none;\n    margin-top: 1rem;\n    padding: 1rem 2rem;\n  }\n  span + span {\n    margin-right: auto;\n  }\n"])));
var ButtonGroup = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 3.2rem;\n  top: 1.35rem;\n"])));
var CategoryMarker = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 16px;\n  height: 16px;\n  border-radius: 8px;\n  margin-right: 1.5rem;\n  display: block;\n"])));

var PointLayerCategory = function PointLayerCategory(_ref) {
  var id = _ref.id,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 0 : _ref$depth,
      pointLayers = _ref.pointLayers,
      subcategories = _ref.subcategories,
      color = _ref.color,
      _onChange = _ref.onChange,
      onChangeAll = _ref.onChangeAll,
      _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen;

  var _useState = useState(defaultOpen),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var toggleCategory = function toggleCategory(e) {
    setIsOpen(!isOpen);
  };

  var handleToggleAll = function handleToggleAll(e) {
    onChangeAll && onChangeAll(id, true, e);
  };

  var handleToggleNone = function handleToggleNone(e) {
    onChangeAll && onChangeAll(id, false, e);
  };

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(CategoryButton, {
    color: "transparent",
    onClick: toggleCategory,
    className: clsx(isOpen && 'open', "btn--depth" + depth)
  }, /*#__PURE__*/React.createElement(CategoryMarker, {
    style: {
      backgroundColor: color
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "gotham14 w500"
  }, i18n.translate(id)), /*#__PURE__*/React.createElement(FiChevronRight, {
    style: {
      transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
      transition: 'transform 200ms linear',
      fontSize: 20
    }
  })), depth === 0 && /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    className: "knockout12",
    onClick: handleToggleAll
  }, "All"), /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    className: "knockout12",
    onClick: handleToggleNone
  }, "None")), /*#__PURE__*/React.createElement(Collapse, {
    isOpen: isOpen
  }, pointLayers.map(function (point) {
    return /*#__PURE__*/React.createElement(LayersInput, {
      key: "layer-input-group-" + point.id,
      layer: point,
      id: "input_" + point.id,
      ind: point.pointIndex,
      isChecked: point.isChecked,
      label: point.label,
      tooltip: point.tooltip,
      onChange: function onChange(e) {
        return _onChange && _onChange(point, e);
      }
    });
  }), subcategories && subcategories.map(function (sub) {
    return /*#__PURE__*/React.createElement(PointLayerCategory, _extends({
      key: sub.id,
      depth: depth + 1,
      onChange: _onChange
    }, sub));
  })));
};

export default PointLayerCategory;